module.exports = __webpack_public_path__ + "static/media/ImageGallery.1ff108a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ImageGallery.png
// module id = 36
// module chunks = 0